import { Global, css } from '@emotion/react'

const globalStyles = css`
  * {
    outline: none !important;
    outline-offset: none !important;
  }
`

const MobileReset = () => (<Global styles={globalStyles} />)

export default MobileReset
